import React from "react";
import Icone from "./Icone";

const EPAISSEURS = { succes: 2.4, danger: 2.4 };

/**
 * Écran « résultat » centré : pastille (ou rond d'attente), titre, contenu.
 * ton : succes | danger | avert | info | attente.
 * Dans le portail, le titre de la carte est le h1 de la page (le volet marque
 * n'a pas de titre de niveau 1) ; `niveau` permet un h2 dans un dialogue.
 */
const EcranResultat = ({ ton = "info", icone = null, titre, children, niveau = 1 }) => {
  const Titre = niveau === 2 ? "h2" : "h1";
  const idTitre = "titre-" + titre.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
  return (
    <section className="centre" aria-labelledby={idTitre} data-ton={ton} role={ton === "attente" ? "status" : undefined}>
      <div className={`pastille ${ton}`}>
        {ton === "attente" ? (
          <span className="spin" aria-hidden="true" />
        ) : (
          <Icone nom={icone} epaisseur={EPAISSEURS[ton] || 2.2} />
        )}
      </div>
      <Titre id={idTitre}>{titre}</Titre>
      {children}
    </section>
  );
};

export default EcranResultat;
